import Icon from '../components/Icon.vue'

Icon.register({
  'hockey-puck': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 160C0 107 114.6 64 256 64S512 107 512 160 397.4 256 256 256 0 213 0 160zM0 242.2V352C0 405 114.6 448 256 448S512 405 512 352V242.2C398.6 324.5 113.5 324.6 0 242.2z'
      }
    ]
  }
})
